import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/create',
    name: 'CreateRedPack',
    component: () => import('../views/Create.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/share',
    name: 'share',
    component: () => import('../views/Share.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/receive',
    name: 'ReceiveRedPack',
    component: () => import('../views/Receive.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/History',
    name: 'History',
    component: () => import('../views/History.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import('../views/Download.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/myRecords',
    name: 'MyRecords',
    component: () => import('../views/MyRecords.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/viewRecords',
    name: 'ViewRecords',
    component: () => import('../views/ViewRecords.vue'),
    meta: {
      keepAlive: false
    }
  }
]

if (process.env.NODE_ENV === 'development') {
  routes.push({
    path: '/test',
    name: 'Test',
    component: () => import('../views/Test.vue')
  })
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router
